<template>
  <div class="">
    <div>
      <div>
        <h5 class="text-h6 q-my-sm">Details</h5>
      </div>
      <q-table
        flat
        bordered
        :data="orders.data"
        separator="cell"
        :columns="columns"
        :loading="loading"
        :rows-per-page-options="[5,10,20,30]"
        :pagination.sync="pagination"
        @request="onRequest"
      >

        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="id" :props="props">
              <a
                :href="`/orders/${
                  props.row.id
                }?edit=true`"
                target="_blank"
              >
                {{ props.row.id }}
              </a>
            </q-td>
            <q-td key="assignee" :props="props">
              {{ props.row.assignee?props.row.assignee.firstName:'' }}
            </q-td>
            <q-td key="price" :props="props">
              {{ (props.row.transport?props.row.transport.totalPrice:0) | currency }}
            </q-td>
            <q-td key="deposit" :props="props">
              {{ (props.row.transport?props.row.transport.deposit:0) | currency }}
            </q-td>
            <q-td key="datePlaced" :props="props">{{ '12-16-21' }}</q-td>
            <q-td key="dateCancelled" :props="props">{{ '12-16-21' }}</q-td>
            <q-td key="origin" :props="props">
              {{ props.row.origin?props.row.origin.city:'' }},
              {{ props.row.origin? props.row.origin.state:'' }}
            </q-td>

            <q-td key="destination" :props="props">
              {{ props.row.destination?props.row.destination.city:'' }},
              {{ props.row.destination?props.row.destination.state:'' }}
            </q-td>
            <q-td key="vehicle" :props="props">
              <div  v-if="props.row.vehicles">
                <div v-for="(vehicle,i) in props.row.vehicles" :key="i">
                  {{  vehicle.year }}
                  {{  vehicle.make }}
                  {{  vehicle.model }}
                </div>
              </div>
            </q-td>
          </q-tr>
        </template>

      </q-table>
    </div>

  </div>
</template>

<script>
  import graphql from '@client/graphql';

  const tcolumns = [
    {
      name: 'id',
      label: 'Order',
      align: 'left'
    },
    {
      name: 'assignee',
      label: 'Assigned To',
      align: 'left'
    },
    {
      name: 'price',
      label: 'Price',
      align: 'left'
    },
    {
      name: 'deposit',
      label: 'Deposit',
      align: 'left'
    },
    {
      name: 'datePlaced',
      label: 'Date Placed',
      align: 'left'
    },
    {
      name: 'dateCancelled',
      label: 'Date Cancelled',
      align: 'left'
    },
    {
      name: 'origin',
      label: 'Origin',
      align: 'left'
    },
    {
      name: 'destination',
      label: 'Destination',
      align: 'left'
    },
    {
      name: 'vehicle',
      label: 'Vehicle',
      align: 'left'
    }
  ];

  export default {
    props: {
      filters: Object
    },
    apollo: {
      currentUser: {
        query: graphql.queries.currentUser
      },
      orders: {
        query: graphql.queries.getStatusOrdersReport,
        variables() {
          return {
            filterBy: this.filters,
            cursor: this.pageInfo
          };
        },
        skip() {
          return !this.isReady;
        },
        watchLoading(isLoading) {
          this.loading = isLoading;
        },
        error(error) {
          this.error = error;
        },
        result(result) {
          if (result.loading) return;
          this.orders = result.data.orders;
          this.pagination.rowsNumber = this.orders.pageInfo.total;
          this.pagination.page = this.orders.pageInfo.page + 1;
          this.pagination.rowsPerPage = this.orders.pageInfo.size;
        },
        errorPolicy: 'all'
      }
    },
    data() {
      return {
        loading: false,
        error: null,
        orders: [],
        columns: tcolumns,
        filterBy: {},
        isReady: false,
        pageInfo: {
          page: 0,
          size: 10
        },
        pagination: {
          page: 1,
          rowsPerPage: 10,
          rowsNumber: 10
        }
      };
    },
    mounted() {
      this.isReady = true;
    },
    methods: {
      onRequest(props) {
        this.pageInfo = { page: props.pagination.page - 1, size: props.pagination.rowsPerPage };
      }
    }
  };
</script>
